import { atom } from "recoil";

export interface balanceStateType {
  SCRT: string;
  JUNO: string;
  OSMO: string;
  sETH: string;
  sUSDT: string;
  sJUNO: string;
}

export const balanceState = atom<balanceStateType>({
  key: "balanceState",
  default: {
    SCRT: "",
    JUNO: "",
    OSMO: "",
    sETH: "",
    sUSDT: "",
    sJUNO: "",
  },
});
